import { useTranslation } from 'react-i18next'
import { SMART_PICKS, getSmartPickImageUrl, type SmartPickBrowsePreset } from '@redevicer/shared'
import ModalCloseButton from './ModalCloseButton'

type Props = {
  onClose: () => void
  onPick: (preset: SmartPickBrowsePreset) => void
}

export default function SmartPicksModal({ onClose, onPick }: Props) {
  const { t } = useTranslation()

  return (
    <div className="vc-guide-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="vc-smart-picks-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="vc-smart-picks-title"
        onClick={(e) => e.stopPropagation()}
      >
        <ModalCloseButton
          className="vc-guide-modal-close"
          onClick={onClose}
          aria-label={t('vc.smartPicks.close')}
        />
        <h2 id="vc-smart-picks-title" className="vc-smart-picks-modal-title">
          {t('vc.smartPicks.modalTitle')}
        </h2>
        <p className="vc-smart-picks-modal-lead">{t('vc.smartPicks.modalLead')}</p>
        <div className="vc-smart-picks-grid">
          {SMART_PICKS.map((item) => (
            <button
              key={item.key}
              type="button"
              className="vc-smart-pick-tile"
              onClick={() => onPick(item.preset)}
            >
              <span className="vc-smart-pick-visual" style={{ background: item.gradient }}>
                <img
                  src={getSmartPickImageUrl(item.key)}
                  alt=""
                  className={`vc-smart-pick-img vc-smart-pick-img--${item.key}`}
                  loading="lazy"
                  decoding="async"
                />
              </span>
              <span className="vc-smart-pick-label">{t(item.titleKey)}</span>
              <span className="vc-smart-pick-sub">{t(item.subtitleKey)}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
